exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input-44f56{width:100%}.submit-15369{text-align:center}", ""]);

// Exports
exports.locals = {
	"input": "input-44f56",
	"submit": "submit-15369"
};